<script>
  let className = 'df fd-c ai-c text-center';
  export { className as class };
</script>




<div class={className}>
  <slot name="rb" />
  <div class="rt">
    <slot name="rt" />
  </div>
</div>



<style>
  .rt {
    opacity: .4;
    transform: scaleY(.85);
    font-size: smaller;
  }
</style>
